import React, { PropsWithChildren } from 'react';

import Container from '@shared/Container';

import { ContentWrapper, WarningIcon } from './styled';

interface IWarningBox {
  my?: number;
}

const WarningBox = ({ children, my }: PropsWithChildren<IWarningBox>) => {
  return (
    <Container maxWidth='lg'>
      <ContentWrapper my={my}>
        <WarningIcon />
        {children}
      </ContentWrapper>
    </Container>
  );
};

export default WarningBox;
